import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import Section from "../../../containers/Section";
import GradientTitle from "../../GradientTitle";
import Header, { HeaderVariant } from "../../Header";
import Paragraph from "../../Paragraph";
import SelectableButton from "../../SelectableButton";
import Testimonal from "../../Testimonial";
import MetricSelector, { MetricSelectorVariant } from "./MetricSelector";
import { PAGE } from "../../../constants/pages";

interface AnalyzeProps {
  title: string[];
  gradientPosition: number;
  description: string;
  testimonialsDescription?: string;
  testimonialsPerson?: string;
  testimonialsPersonTitle?: string;
  testimonialsPersonImage?: any;
  features?: any;
  page?: string;
}

const AnalyzeSection: React.FC<AnalyzeProps> = props => {
  const {
    title,
    gradientPosition,
    description,
    testimonialsDescription,
    testimonialsPerson,
    testimonialsPersonTitle,
    testimonialsPersonImage,
    features,
    page
  } = props;

  const [selectedMetricSelectorVariant, setSelectedMetricSelectorVarient] =
    React.useState<MetricSelectorVariant>(features && features[0]);

  const headshot = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "headshots/ju-rhyu.png" }) {
        childImageSharp {
          gatsbyImageData(width: 48, height: 48, layout: FIXED)
        }
      }
    }
  `);

  const testimonial = (
    <Testimonal
      quote={testimonialsDescription}
      name={testimonialsPerson}
      role={testimonialsPersonTitle}
      image={
        testimonialsPerson && headshot?.file?.childImageSharp?.gatsbyImageData
      }
    />
  );

  return (
    <Section>
      <div className="flex flex-col-reverse lg:flex-row lg:py-36 py-20 lg:items-center">
        <div className="block mt-8 md:mt-16 lg:hidden">{testimonial}</div>
        <div className="flex items-center justify-center lg:justify-start lg:w-1/2">
          <MetricSelector page={page} feature={selectedMetricSelectorVariant} />
        </div>
        <div className="text-center lg:text-left lg:w-1/2">
          <GradientTitle
            gradientPosition={gradientPosition}
            className="max-w-xl mx-auto lg:mx-0"
            color="purple"
            variant={HeaderVariant.h2}
            title={title}
            lineBreak={page !== PAGE.SELLICS_JOINS_PERPETUA ? true : false}
          />
          <Paragraph className="text-2xl mb-4 max-w-xl mx-auto lg:mx-0">
            {description && description}
          </Paragraph>
          <div className="mb-11">
            <div className="flex flex-wrap items-center justify-center lg:justify-start">
              {features &&
                features?.map(feature => {
                  return (
                    <SelectableButton
                      key={feature.id}
                      text={feature?.name}
                      active={
                        selectedMetricSelectorVariant.name === feature.name
                      }
                      onClick={() => setSelectedMetricSelectorVarient(feature)}
                      className="sm:mr-4 mt-4"
                    />
                  );
                })}
            </div>
          </div>
          <div className="hidden lg:block">{testimonial}</div>
        </div>
      </div>
    </Section>
  );
};

export default AnalyzeSection;
